import { memo } from "react";

const QuestionSelectorItem = ({
  selected = false,
  onSelected,
  thumbnail,
  tag = "",
  imageClass = "",
  mode = "multiple",
}) => {
  const handleSelect = () => {
    if (onSelected) {
      onSelected(!selected);
    }
  };

  const renderSelectedIcon = () => {
    if (mode === "multiple") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M11 0.5C5.20156 0.5 0.5 5.20156 0.5 11C0.5 16.7984 5.20156 21.5 11 21.5C16.7984 21.5 21.5 16.7984 21.5 11C21.5 5.20156 16.7984 0.5 11 0.5ZM15.5352 7.57109L10.5992 14.4148C10.5302 14.5111 10.4393 14.5896 10.3339 14.6437C10.2286 14.6978 10.1118 14.7261 9.99336 14.7261C9.87491 14.7261 9.75816 14.6978 9.6528 14.6437C9.54743 14.5896 9.45649 14.5111 9.3875 14.4148L6.46484 10.3648C6.37578 10.2406 6.46484 10.0672 6.61719 10.0672H7.71641C7.95547 10.0672 8.18281 10.182 8.32344 10.3789L9.99219 12.6945L13.6766 7.58516C13.8172 7.39062 14.0422 7.27344 14.2836 7.27344H15.3828C15.5352 7.27344 15.6242 7.44688 15.5352 7.57109Z"
            fill="#22C55E"
          />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          fill="none"
          viewBox="0 0 22 22"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="10.5" stroke="#22C55E" />
          <circle cx="11" cy="11" r="6" fill="#22C55E" />
        </svg>
      );
    }
  };

  return (
    <div
      className={`keduall-question-item cursor-pointer ${
        selected ? "is-selected" : ""
      }`}
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        handleSelect();
      }}
    >
      {selected && (
        <div className="keduall-question-item-selected">
          {renderSelectedIcon()}
        </div>
      )}
      <div className="keduall-question-item-content">
        <img
          className={`card-image ${imageClass || ""}`}
          src={thumbnail}
          alt={`${tag} thumbnail`}
        />
        <div className="card-tag keduall-typography text-12-normal-400 text-default-txt text-center">
          {tag}
        </div>
      </div>
    </div>
  );
};

export default memo(QuestionSelectorItem);
